import React, { createContext, useContext, useEffect, useState } from 'react';
import ApiService from 'services/ApiService';
import { repeatEffect, settingsConfig } from 'utils/commonFunc';
import module from "pages/css/moduleStyle.module.css";
import styles from "pages/css/busOp.module.css";


const AutoDrive = createContext(null);

export function SwItsAutoDriveProvider({ children }) {
    const [currentData, setCurrentData] = useState();

    useEffect(() => {
        return repeatEffect(async () => {
            const response = await ApiService.get("newdashboard/ftrtrf/GetSelfDrivingStat");
            if (response.status === 200) {
                const data = response.data;
                setCurrentData({
                    // updateTime: data.updateTime,
                    runCnt: data[0].runCnt,
                    totalCnt: data[0].totalCnt
                });

            }
        }, settingsConfig().contentUpdateDelaySec);
    }, []);

    return (
        <AutoDrive.Provider value={currentData}>
            {children}
        </AutoDrive.Provider>
    );
}

// 승하차 인원 상위 정류소 현황
export function SwItsAutoDriveDataInfo() {
    const currentData = useContext(AutoDrive);
    if (!currentData) return null;

    return (
        <>
            <div className="flx flx_col a_center">
                <div className="flx a_flx_end">
                    <span className="subTxt" style={{ marginRight: "10px" }}>
                        운행중
                    </span>
                    <span className="nbr">{currentData.runCnt}</span>
                    <span className="subTxt" style={{ marginLeft: "10px" }}>
                        대
                    </span>
                    <span className="subTxt sls">
                        |
                    </span>
                    <span className="subTxt" style={{ marginRight: "20px" }}>
                        총
                    </span>
                    <span className="nbr">{currentData.totalCnt}</span>
                    <span className="subTxt" style={{ marginLeft: "20px" }}>
                        대
                    </span>
                </div>
            </div>
        </>
    );
}






